// eslint-disable-next-line import/prefer-default-export
export const ITEMS_PER_PAGE = 30;
